import { createContext, useReducer, useCallback } from "react";
import AdminReducer from "./AdminReducer";
import { getAdmins } from "./apiCalls";

const INITIAL_STATE = {
    admins: [],
    isFetching: false,
    error: false,
};

export const AdminContext = createContext(INITIAL_STATE);

export const AdminContextProvider = ({ children }) => {
    const [state, dispatch] = useReducer(AdminReducer, INITIAL_STATE);

    const fetchAdmins = useCallback(
        async (toast, forceRefresh = false) => {
            // Data already exists → don't call API again
            if (state.admins.length > 0 && !forceRefresh) {
                return;
            }

            await getAdmins(dispatch, toast);
        },
        [state.admins.length]
    );

    return (
        <AdminContext.Provider
            value={{
                admins: state.admins,
                isFetching: state.isFetching,
                error: state.error,
                dispatch,
                fetchAdmins,
            }}
        >
            {children}
        </AdminContext.Provider>
    );
};